import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';

import { QueryProvider } from '@/components/providers/query-provider';
import { router } from '@/routes/router';

import './styles/globals.css';

const container = document.getElementById('root');
if (container === null) throw new Error('Missing #root in index.html');

// AuthProvider lives inside AppLayout (not here), because it uses
// useNavigate/useLocation — hooks that only work inside a router context.

createRoot(container).render(
  <StrictMode>
    <QueryProvider>
      <RouterProvider router={router} />
    </QueryProvider>
  </StrictMode>,
);
